module.exports = __webpack_public_path__ + "static/media/droopy_lower.beaa34dc.svg";